import React from "react";
import styled from "styled-components";
import ReactPlayer from "react-player";

const CardQuestion = styled.div`
  color: #315c89;
  width: 63%;
  font-weight: 700;
  padding: 10px 5px 0px 10px;
  font-size: 20px;
  @media (max-width: 530px) {
    font-size: 16px;
  }
  @media (max-width: 768px) and (min-width: 531px) {
    font-size: 20px;
  }
  @media (max-width: 1440px) and (min-width: 769px) {
    font-size: 16px;
  }
`;
const CardAuthor = styled.div`
  color: #315c89;
  font-weight: 700;
  font-size: 11px;
  @media (max-width: 530px) {
    font-size: 9px;
  }
  @media (max-width: 768px) and (min-width: 531px) {
    font-size: 18px;
  }
`;
const HoverCornerImage = styled.img`
  display: none;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 37%;
  max-height: 100%;
`;
const CardTitle = styled.div`
  color: #315c89;
  font-weight: 400;
  font-size: 8px;
  margin-bottom: 5px;

  @media (max-width: 530px) {
    font-size: 6px;
  }
  @media (max-width: 768px) and (min-width: 531px) {
    font-size: 14px;
  }
`;
const CornerImage = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 37%;
  max-height: 100%;
`;
const Card = styled.div`
  background: #fff;
  position: relative;
  width: 300px;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: 0.2s;

  @media (max-width: 768px) and (min-width: 531px) {
    width: 100%;
    height: 250px;
  }

  &:hover {
    background: #315c89;
    cursor: pointer;
  }

  &:hover ${CardQuestion}, :hover ${CardTitle},:hover ${CardAuthor} {
    color: #fff;
  }
  &:hover ${CardQuestion}, :hover ${CardTitle},:hover ${CardAuthor} {
    color: #fff;
  }
  &:hover ${CornerImage} {
    display: none;
  }
  &:hover ${HoverCornerImage} {
    display: block;
  }
`;

const Modal = styled.div`
  position: fixed; /* Stay in place */
  z-index: 99; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  padding-top: 70px;
  background-color: rgb(36, 76, 107, 0.8); /* Black w/ opacity */
  @media (max-width: 425px) {
    padding-top: 30px;
  }
`;
const ModalContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ModalWrapper = styled.div`
  position: relative;
  width: 80%;
  height: 700px;
  overflow: scroll;
  background: #fff;
  display: flex;
  flex-direction: row;
  padding: 30px 50px;
  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0px;
  }
  @media (max-width: 425px) {
    padding: 0px;
  }
  @media (max-height: 750px) {
    height: 550px;
  }
`;
const ModalDescription = styled.div`
  width: 70%;
  height: 100%;
  min-height: 850px;
  background: #fff;
  padding: 30px;
  @media (max-width: 530px) {
    width: calc(100% - 60px);
  }
  @media (max-width: 768px) and (min-width: 531px) {
    width: calc(100% - 120px);
    padding: 60px;
  }
  @media (max-width: 1124px) and (min-width: 769px) {
    width: 60%;
  }
  @media (max-height: 750px) {
    min-height: 700px;
  }
`;
const Videos = styled.div`
  width: 25%;
  /*   max-height: 100%; */
  padding: 30px 0;
  @media (max-width: 530px) {
    width: calc(100% - 40px);
    padding: 20px;
  }
  @media (max-width: 768px) and (min-width: 531px) {
    width: calc(100% - 120px);
    padding: 60px;
  }
  @media (max-width: 1124px) and (min-width: 769px) {
    width: 40%;
  }
  & > div {
    width: 100%;
    margin-bottom: 20px;
    border: 1px solid #315c89;
    @media (max-width: 530px) {
      margin: 0 0 10px 0;
    }
    @media (max-width: 768px) and (min-width: 531px) {
      margin: 0 0 10px 0;
    }
  }
`;
const Close = styled.span`
  position: absolute;
  top: 0;
  right: 40px;
  color: #315c89;
  font-size: 40px;
  font-weight: 700;
  transition: 0.3s;
  cursor: pointer;
  @media (max-width: 531px) {
    right: 5px;
  }
  & > :hover,
  :focus {
    color: #bbb;
    text-decoration: none;
  }
`;

const Title = styled.div`
  color: #315c89;
  font-size: 30px;
  margin-bottom: 30px;
  @media (max-width: 425px) {
    font-size: 20px;
  }
`;
const Author = styled.div`
  color: #315c89;
  font-size: 22px;
  margin-top: 30px;
  @media (max-width: 425px) {
    font-size: 15px;
  }
`;
const Description = styled.div`
  margin-top: 25px;
  margin-bottom: 25px;
  color: #315c89;
  font-size: 18px;
  @media (max-width: 425px) {
    font-size: 12px;
  }
`;
const Flex = styled.div`
  display: flex;
  flex-direction: ${(props) => props.direction || ""};
  justify-content: ${(props) => props.justify || ""};
  align-items: ${(props) => props.align || ""};
`;
const Color = styled.div`
  background: ${(props) => props.background || "#CF5155"};
  height: 3px;
  width: 20px;
  margin-right: 5px;
  @media (max-width: 530px) {
    width: 10px;
  }
`;
const PlayerContainer = styled.div`
  position: relative;
  padding-top: 56.25%; /* 720 / 1280 = 0.5625 */
  width: 100%;
`;

const ReactPlayerStyled = styled(ReactPlayer)`
  position: absolute;
  width: 100% !important;
  height: 100% !important;
  top: 0;
  left: 0;
`;
function CardModal({
  url,
  handleClick,
  setOpenModal,
  selectedCard,
  videoList,
  ...props
}) {
  return (
    <Modal>
      <ModalContent name="modal-content">
        <ModalWrapper name="modal-wrapper">
          <Close onClick={() => setOpenModal(false)}>&times;</Close>
          <ModalDescription name="modal-description">
            <Title>{selectedCard && selectedCard.question}</Title>
            <PlayerContainer>
              <ReactPlayerStyled url={selectedCard && selectedCard.video_url} />
            </PlayerContainer>
            <Author>
              {selectedCard && selectedCard.author_name}{" "}
              {selectedCard && selectedCard.author_title
                ? `- ${selectedCard.author_title}`
                : ""}
            </Author>
            <Description>
              {selectedCard && selectedCard.description}
            </Description>
          </ModalDescription>
          <Videos name="videos">
            {videoList &&
              videoList.map((card, i) => (
                <Card key={i} onClick={() => handleClick(card)}>
                  <CardQuestion>{card.question}</CardQuestion>
                  <Flex direction="row" align="center">
                    {card.author_name && <Color background={card.color} />}
                    <Flex direction="column">
                      <CardAuthor>{card.author_name}</CardAuthor>
                      <CardTitle>{card.author_title}</CardTitle>
                    </Flex>
                  </Flex>
                  <CornerImage src={card.corner_image_url} alt="" />
                  <CornerImage src={card.corner_image_url} alt="" />
                  {card.hover_image && (
                    <HoverCornerImage src={card.hover_image_url} />
                  )}
                  {!card.hover_image && (
                    <HoverCornerImage src={card.corner_image_url} />
                  )}
                </Card>
              ))}
          </Videos>
        </ModalWrapper>
      </ModalContent>
    </Modal>
  );
}
export default CardModal;
